import * as TYPES from './types';

export default {
    [TYPES.SET_FORMREQUIRED](payload = {}) {
        this.formRequired = payload
    },

    [TYPES.GET_FORMREQUIRED]() {
        return this.axiosIns.get('/api-site/place-data?fetcher=data&source=formRequired')
            .then(res => {
                let data = res.data || {};
                if (typeof data === 'string') {
                    data = JSON.parse(data);
                }
                this[TYPES.SET_FORMREQUIRED](data);
            })
    }
}